import Image from "next/image";
import { BANNER_SWIPER_COMPANY_ITEMS } from "@/lib/utils";
import GlobalForm from "@/components/forms/GlobalForm";
import {
  FinanceAndAccountingSubcategory,
  FormHeading,
  SuccessMessageType,
  VerticalCategory,
} from "@/interface/types";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { useEffect, useRef } from "react";

const UspBannerMobile = () => {
  const autoplayRef = useRef(
    Autoplay({
      delay: 1500,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    }),
  );

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      dragFree: true,
      containScroll: "trimSnaps",
    },
    [autoplayRef.current],
  );

  useEffect(() => {
    if (emblaApi && autoplayRef.current) {
      autoplayRef.current.play();
    }
  }, [emblaApi]);

  return (
    <>
      <div className="w-full bg-white">
        <div className="mx-auto w-full 2xl:h-[700px] md:h-[95vh] h-[auto] xl:px-0 md:px-6 lg:!px-6 px-0 relative square_grid_bg md:pb-0 pb-[0px]">
          <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-5 relative">
            <div className="flex justify-between flex-wrap 2xl:items-center items-center 2xl:h-[650px] md:h-[65vh] h-[auto]">
              <div className="md:pt-5 pt-[65px] pb-[0px] w-full md:pb-16 relative 2xl:top-[50px] md:top-[120px] mt-0 md:ml-[70px]">
                <Image
                  src="/accounting/usp_mobile.png"
                  alt="Work in the US"
                  className="mx-auto mb-[10px] mt-[10px] w-[72%]"
                  width={600}
                  height={225}
                />

                <div className="text-center">
                  <p className="font-medium text-[20px] leading-[23px] text-[#202852]">
                    Miles has cracked the puzzle for
                    <br /> Global Accountants!
                    <br />
                    <span className="font-bold text-[16px] leading-[27px]">
                      {" "}
                      Accountants worldwide can now
                    </span>
                  </p>
                  <div className="flex flex-col gap-1 justify-center">
                    <h1 className="text-[#0C1F33] text-center text-[40px] not-italic font-bold leading-[1.1] tracking-[-1.6px]">
                      Work in the US
                    </h1>
                    <hr className="w-[114px] h-[1px] border-none bg-[#C6C6C6] mx-auto" />
                    <div className="w-[340px] mx-auto relative">
                      <Image
                        src="/accounting/mob_left_arrow.png"
                        alt="CPA Recruiting firms"
                        className="absolute left-[88px] bottom-1"
                        width={18}
                        height={28}
                      />
                      <p className="text-[#0C1F33] font-semibold text-[14px] leading-[18px] text-center pt-[5px]">
                        Starting Salary
                      </p>
                      <Image
                        src="/accounting/mob_right_arrow.png"
                        alt="CPA Recruiting firms"
                        className="absolute right-[88px] bottom-1"
                        width={14}
                        height={31}
                      />
                    </div>

                    <p className="pt-0">
                      <span className="bg-[#FFBA08] text-[16px] leading-[22px] font-bold text-[#000] text-center px-[5px] py-[2px]">
                        $60,000+
                      </span>
                    </p>
                  </div>

                  <div
                    className="p-4 border border-white rounded-2xl m-4"
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
                      boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
                      backdropFilter: "blur(28px)",
                    }}
                  >
                    <Image
                      src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
                      alt="star group"
                      width={34}
                      height={38}
                      className="absolute top-1 left-0"
                    />
                    <GlobalForm
                      course="USP"
                      courseId={3}
                      formHeading={
                        FormHeading.WORLD_FAVORITE_CMA_CPA_INSTRUCTOR
                      }
                      formType="page"
                      isAStepperForm={true}
                      pageType="business page"
                      subCategory={FinanceAndAccountingSubcategory.USP}
                      submitButtonName="Download Brochure"
                      successMessage={SuccessMessageType.ACCOUNTING}
                      verticalName={VerticalCategory.FINANCE_AND_ACCOUNTING}
                      showSVG={false}
                      darkBackground={false}
                    />
                  </div>

                  <div className="mt-5">
                    <div className="banner_card ">
                      <div className="flex items-center justify-between text-[#202852] border-[#3174d6]">
                        <div>
                          <p className="text-center text-[20px] not-italic font-semibold leading-[normal] tracking-[-1.2px] pb-[4px]">
                            70,000+
                          </p>
                          <p className="text-center text-[10px] text-[#202852] not-italic font-medium leading-[normal] tracking-[-0.48px] capitalize">
                            Global Alumni
                          </p>
                        </div>
                        <div className="grey_divider"></div>
                        <div>
                          <p className="text-center text-[20px] not-italic text-[#202852] font-semibold leading-[normal] tracking-[-1.2px] pb-[4px]">
                            600+
                          </p>
                          <p className="text-center text-[10px] not-italic text-[#202852] font-medium leading-[normal] tracking-[-0.48px] capitalize">
                            Corporates
                          </p>
                        </div>
                        <div className="grey_divider"></div>
                        <div>
                          <p className="text-center text-[20px] not-italic text-[#202852] font-semibold leading-[normal] tracking-[-1.2px] pb-[4px]">
                            100+
                          </p>
                          <p className="text-center text-[10px] not-italic text-[#202852] font-medium leading-[normal] tracking-[-0.48px] capitalize">
                            Universities
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="w-full mt-[35px]">
                    <h2 className=" text-[13px] text-[#848484] flex justify-center items-center font-medium">
                      <Image
                        src="/cpa/StarFour.png"
                        alt="CPA Recruiting firms"
                        className=""
                        width={12}
                        height={12}
                      />
                      <span className="leading-[1] mx-3 text-12px font-medium">
                        {" "}
                        OUR ALUMNI WORK AT
                      </span>
                      <Image
                        src="/cpa/StarFour.png"
                        alt="CPA Recruiting firms"
                        className=""
                        width={12}
                        height={12}
                      />
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pb-[20px] pt-[10px]">
            <div className="embla overflow-hidden w-full pb-4" ref={emblaRef}>
              <div
                className="embla__container flex"
                style={{
                  backfaceVisibility: "hidden",
                  transform: "translate3d(0, 0, 0)",
                }}
              >
                {BANNER_SWIPER_COMPANY_ITEMS?.map((item) => (
                  <div
                    key={item?.companyImageURL}
                    className="embla__slide flex-[0_0_auto] flex-shrink-0 flex items-center justify-center"
                    style={{
                      minWidth: "80px",
                      marginRight: "25px",
                    }}
                  >
                    <Image
                      src={item?.companyImageURL}
                      alt={item?.companyImageURL}
                      className=" mx-auto"
                      width={item?.companyImageWidth}
                      height={item?.companyImageheight}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Image
            src="/accounting/usp_mobile_banner.png"
            alt="accounting jobs in usa"
            className="absolute top-0 bottom-0 right-0 left-0 md:hidden block w-full "
            width={360}
            height={150}
          />

          <Image
            src="/images/accounting/usp/mobile-banner-bg.png"
            alt="Work in the US"
            className="absolute left-0 right-0 bottom-[-25px] w-full"
            width={360}
            height={225}
          />
        </div>
      </div>
    </>
  );
};

export default UspBannerMobile;
